"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NowtilusAdsParser = void 0;
const js_player_shared_1 = require("@ericssonbroadcastservices/js-player-shared");
const constants_1 = require("../utils/constants");
const vast_1 = require("../utils/vast");
const AbstractAdsParser_1 = require("./AbstractAdsParser");
class NowtilusAdsParser extends AbstractAdsParser_1.AbstractAdsParser {
    constructor(format, ads) {
        super();
        if (ads.clips) {
            this.clips = ads.clips;
            this.isLive = false;
        }
        else if (format.vastUrl) {
            this.vastUrl = format.vastUrl;
            this.isLive = true;
        }
    }
    init() {
        if (!this.vastUrl && (!this.clips || !this.clips.length)) {
            console.warn("[Nowtilus] Can't monitor stream, no clips or vastUrl");
            return;
        }
        if (!this.isLive) {
            this.initVOD();
        }
        else if (this.vastUrl) {
            this.initLive();
        }
    }
    initLive() {
        this.poll();
        this.longPoll = window.setInterval(() => __awaiter(this, void 0, void 0, function* () {
            this.poll();
        }), 5000);
    }
    initVOD() {
        if (!this.clips)
            return;
        let time = 0;
        let adDuration = 0;
        let adBlock;
        const adBlocks = [];
        this.clips.forEach((clip, index) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            if (clip.category === "vod") {
                adBlock = undefined;
            }
            else {
                if (!adBlock) {
                    adBlock = {
                        startTime: time,
                        endTime: time,
                        duration: 0,
                        relativeStartTime: time - adDuration,
                        ads: [],
                    };
                    adBlocks.push(adBlock);
                }
                adBlock.endTime += (_a = clip.duration) !== null && _a !== void 0 ? _a : 0;
                adBlock.duration += (_b = clip.duration) !== null && _b !== void 0 ? _b : 0;
                adBlock.ads.push({
                    id: `${time}_${index}_${clip.titleId}`,
                    title: (_c = clip.title) !== null && _c !== void 0 ? _c : "",
                    duration: (_d = clip.duration) !== null && _d !== void 0 ? _d : 0,
                    system: "",
                    trackingEvents: Object.assign({ [js_player_shared_1.TrackingEvent.IMPRESSION]: [
                            ...((_e = clip.impressionUrlTemplates) !== null && _e !== void 0 ? _e : []),
                        ], [js_player_shared_1.TrackingEvent.CLICK_THROUGH]: [
                            ...((_g = (_f = clip.videoClicks) === null || _f === void 0 ? void 0 : _f.clickTrackingUrls) !== null && _g !== void 0 ? _g : []),
                        ] }, ((_h = clip.trackingEvents) !== null && _h !== void 0 ? _h : [])),
                    clickThrough: (_j = clip.videoClicks) === null || _j === void 0 ? void 0 : _j.clickThroughUrl,
                });
                adDuration += (_k = clip.duration) !== null && _k !== void 0 ? _k : 0;
            }
            time += (_l = clip.duration) !== null && _l !== void 0 ? _l : 0;
        });
        adBlocks.forEach((adBlock) => {
            this.emit(constants_1.StitcherEvent.ADBLOCK, adBlock);
        });
    }
    poll() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.vastUrl) {
                return console.error("vastUrl not defined");
            }
            try {
                const response = yield fetch(this.vastUrl, {
                    headers: {
                        accept: "application/json",
                    },
                });
                if (!response.ok)
                    throw new Error("[Nowtilus] something went wrong when fetching the VAST JSON");
                if (response.status !== 200) {
                    return;
                }
                const data = yield response.json();
                if (!data.time) {
                    throw new Error("[Nowtilus] VAST response invalid, no time availble");
                }
                if (data.time === this.vastStartTime) {
                    // the adblock has already been handled
                    return;
                }
                const ads = (0, vast_1.parseVAST)(data.vast, data.time.toString());
                this.vastStartTime = data.time;
                const adBlock = {
                    startTime: data.time,
                    duration: ads.reduce((duration, ad) => duration + ad.duration, 0),
                    relativeStartTime: data.time,
                    endTime: ads.reduce((endTime, ad) => endTime + ad.duration, data.time),
                    ads,
                };
                this.emit(constants_1.StitcherEvent.ADBLOCK, adBlock);
            }
            catch (error) {
                console.error("[Nowtilus] something went wrong when fetching the vast", error);
            }
        });
    }
    destroy() {
        super.destroy();
        clearInterval(this.longPoll);
    }
}
exports.NowtilusAdsParser = NowtilusAdsParser;
//# sourceMappingURL=NowtilusAdsParser.js.map